import ODropDownMenu from '../DropDownMenu/ODropDownMenu';

const MuiGridOptions = ({ children }) => {
  const muiOptions = [
    {
      title: 'Prva opcija',
      subtitle: 'Opis neke prve opcije',
      path: 'profil',
      id: 1,
      icon: 'fas fa-user',
      color: '#2f3a3f',
      onClick: () => {},
    },
    {
      title: 'Druga opcija',
      subtitle: 'Kratak opis druge opcije',
      path: 'promena-podataka',
      id: 2,
      icon: 'fas fa-unlock-alt',
      color: '#2f3a3f',
      onClick: () => {},
    },
    {
      title: 'Treća',
      subtitle: 'Druga boja naslova i ikonice',
      path: 'login',
      id: 3,
      icon: 'fas fa-sign-out-alt',
      color: '#ff5552',
      onClick: () => {},
    },
  ];

  return (
    <ODropDownMenu align="end" position="initial" options={muiOptions}>
      {children}
    </ODropDownMenu>
  );
};

export default MuiGridOptions;
